import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
//import DatePicker from 'react-datepicker';
//import ReactInputMask from 'react-input-mask';
//import Calendar from 'react-calendar';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import { pt } from 'date-fns/locale';
import InputMask from 'react-input-mask';

/**
 * 
 *  {{filtroDia === 'Personalizado' ? (
										<div
											style={{
												marginLeft: 20,
												display: 'flex',
												flexDirection: 'column',
												flex: 1,
											}}>
											<div className='personalizado-date-picker-container'>
												De:
												<DatePicker
													className='personalizado-date-picker'
													name='data_inicial'
													dateFormat='dd/MM/yyyy'
													selected={stringToDate(dataCartaoPreDiaDaSemana)}
													onChange={(date) => {
														handleChangePreData(date);
													}}
													locale='pt-BR'
													customInput={<ReactInputMask mask='99/99/9999' />}
												/>
											</div>
											<Calendar
												prev2Label={null}
												next2Label={null}
												locale='pt-BR'
												className='personalizado-calendar'
												value={stringToDate(dataCartaoPreDiaDaSemana)}
												onChange={(date) => {
													handleChangePreData(date);
												}}
											/>
										</div>
									) : null}
									{filtroDia === 'Personalizado' ? (
										<div
											style={{
												marginLeft: 20,
												display: 'flex',
												flexDirection: 'column',
												flex: 1,
											}}>
											<div className='personalizado-date-picker-container'>
												De:
												<DatePicker
													className='personalizado-date-picker'
													name='data_inicial'
													dateFormat='dd/MM/yyyy'
													selected={stringToDate(dataCartao)}
													onChange={(date) => {
														handleChangeDateInicial(date);
														setCalendarDropdownShow(false);

													}}
													locale='pt-BR'
													customInput={<ReactInputMask mask='99/99/9999' />}
												/>
											</div>
											<Calendar
												prev2Label={null}
												next2Label={null}
												locale='pt-BR'
												className='personalizado-calendar'
												value={stringToDate(dataCartao)}
												onChange={(date) => {
													handleChangeDateInicial(date);
													setCalendarDropdownShow(false);

												}}
											/>
										</div>
									) : null}} props 
 * 
 */

function CalendarDropDown(props) {
	const {
		handleChangeDropdown,
		handleChangeRange,
		range,
		filtroDia,
		alignUp,
		dontShow,
	} = props;
	////console.log(range);

	//console.log(alignUp,dontShow)

	//const [personalizadoInicial, setPersonalizadoInicial] = useState(		moment().toDate());

	const listaFiltrosDia = [
		'Hoje',
		'Ontem',
		'Este mês',
		'Últimos 30 dias',
		//'Personalizado',
	];

	return (
		<Dropdown.Menu
			align={alignUp && 'up'}
			className='shadow'
			style={{
				background: '#F6F6F6',
				boxShadow: '#0000001A',
				borderWidth: 1,
				borderColor: '#EBEBEB',
				border: 'solid 1px #EBEBEB',
				padding: 10,
				display: 'flex',
				flexDirection: 'row',

				//transition: 'width 1s',
			}}>
			<div>
				{listaFiltrosDia.map((dia) => {
					return (
						<Dropdown.Item
							onClick={(e) => {
								e.preventDefault();
								handleChangeDropdown(dia);
							}}
							className={
								dia === filtroDia
									? 'Dropdown-menu-item-selected'
									: 'Dropdown-menu-item'
							}
							style={{
								//background: '#FFFFFF',
								//color: '#7D9828',
								fontFamily: 'Roboto',
								fontSize: 16,
								marginBottom: 5,
								borderRadius: 8,
							}}>
							{dia}
						</Dropdown.Item>
					);
				})}
				<Dropdown.Item
					onClick={(e) => {
						e.preventDefault();
						handleChangeDropdown('Personalizado');
					}}
					className={
						'Personalizado' === filtroDia
							? 'Dropdown-menu-item-selected'
							: 'Dropdown-menu-item'
					}
					style={{
						//background: '#FFFFFF',
						//color: '#7D9828',
						fontFamily: 'Roboto',
						fontSize: 16,
						marginBottom: 5,
						borderRadius: 8,
					}}>
					{'Personalizado'}
				</Dropdown.Item>
			</div>

			{filtroDia === 'Personalizado' ? (
				<RangeCalendar
					dontShow={dontShow}
					filtroDia={filtroDia}
					handleChangeRange={handleChangeRange}
					range={range}
				/>
			) : null}
		</Dropdown.Menu>
	);
}

function RangeCalendar(props) {
	const { handleChangeRange, range, dontShow } = props;

	const [dataInicial, setDataInicial] = useState(
		moment(range[0].startDate).format('DD/MM/YYYY')
	);
	const [dataFinal, setDataFinal] = useState(
		moment(range[0].endDate).format('DD/MM/YYYY')
	);

	const [show, setShow] = useState(false);

	useEffect(() => {
		const { range } = props;
		setDataInicial(moment(range[0].startDate).format('DD/MM/YYYY'));
		setDataFinal(moment(range[0].endDate).format('DD/MM/YYYY'));
	}, [props]);

	useEffect(() => {
		setTimeout(() => {
			setShow(true);
		}, 0);
	}, []);

	function handleSubmit() {
		if (
			moment(dataInicial, 'DD/MM/YYYY', true).isValid() &&
			moment(dataFinal, 'DD/MM/YYYY', true).isValid()
		) {
			if (
				+moment(dataInicial, 'DD/MM/YYYY').toDate() >=
				+moment(dataFinal, 'DD/MM/YYYY').toDate()
			) {
				const item = {
					selection: {
						startDate: moment(dataInicial, 'DD/MM/YYYY').toDate(),
						key: 'selection',
						endDate: moment(dataInicial, 'DD/MM/YYYY').toDate(),
					},
				};

				handleChangeRange(item);
			} else {
				////console.log( )

				const item = {
					selection: {
						startDate: moment(dataInicial, 'DD/MM/YYYY').toDate(),
						key: 'selection',
						endDate: moment(dataFinal, 'DD/MM/YYYY').toDate(),
					},
				};

				handleChangeRange(item);
			}

			////console.log(item);
		}
	}

	return (
		<div
			style={{
				opacity: show ? 1 : 0,
				transition: 'all 1s',
				display: dontShow && 'flex',
				alignItems: dontShow && 'flex-start',
				justifyContent: dontShow && 'center',
				padding: dontShow && 0,
			}}>
			{
				<div className='rdrDateDisplayWrapper'>
					<div
						className='rdrDateDisplay'
						style={{
							color: 'rgb(125,152,40)',
							display: dontShow && 'flex',
							flexDirection: dontShow && 'column',
							margin: dontShow && 0,
							marginRight: 0,
							marginLeft: 0,
						}}>
						<span
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
								width: dontShow && 150,
								marginBottom: dontShow && 10,
							}}
							className='rdrDateInput rdrDateDisplayItem'>
							<p style={{ fontWeight: '700', marginLeft: 10 }}>De:</p>
							<InputMask
								value={dataInicial}
								onChange={(e) => {
									setDataInicial(e.target.value);
								}}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										////console.log(e.target.value);

										handleSubmit();
									}
								}}
								placeholder='data inicial'
								mask='99/99/9999'
							/>
						</span>
						<span
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
								width: dontShow && 150,
								margin: dontShow && 0,
							}}
							className='rdrDateInput rdrDateDisplayItem'>
							<p style={{ fontWeight: '700', marginLeft: 10 }}>Até:</p>

							<InputMask
								value={dataFinal}
								onChange={(e) => {
									setDataFinal(e.target.value);
								}}
								placeholder='data final'
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										////console.log(e.target.value);

										handleSubmit();
									}
								}}
								//\\Até:
								mask={`99/99/9999`}
							/>
						</span>
					</div>
				</div>
			}

			{dontShow ? null : (
				<DateRange
					//showMonthAndYearPickers={false}
					//showMonthArrow={false}
					showDateDisplay={false}
					//twoStepChange={true}

					//scroll={{enabled: true}}
					//customInput={<InputMask mask='99/99/9999' />}
					startDatePlaceholder='data inicial'
					endDatePlaceholder='data final'
					rangeColors={['#7D9828', '#FFFFFF']}
					editableDateInputs={true}
					onChange={(item) => {
						////console.log(item);
						handleChangeRange(item);
					}}
					moveRangeOnFirstSelection={false}
					ranges={range}
					months={2}
					direction='horizontal'
					locale={pt}
					dateDisplayFormat='P'
					//dateDisplayFormat="'data': P"
					monthDisplayFormat='MMMM yyy'
					weekdayDisplayFormat='EEEEE'
					weekStartsOn={0}
					//
				/>
			)}
		</div>
	);
}

export default CalendarDropDown;
